import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class HorizontalMenuState {
	public activeSelection$: Observable<string>;
	private activeSelection: Subject<string>;

	public constructor() {
		this.activeSelection = new Subject();
		this.activeSelection$ = this.activeSelection.asObservable().pipe(distinctUntilChanged());
	}

	public setActive(name: string) {
		this.activeSelection.next(name);
	}
}
